// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-section {
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
}
.accordion-section .accordion {
  background-color: #ffffff;
  color: #444;
  cursor: pointer;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  outline: none;
  transition: background-color 0.3s ease-in-out;
}
.accordion-section .accordion .arrow {
  border: 1px solid var(--sebrae-dark-gray2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.accordion-section .accordion figure {
  margin: 0;
}
.accordion-section .accordion-title {
  margin: 0;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  color: var(--sebrae-dark-gray2);
}
.accordion-section .accordion-icon {
  margin-left: auto;
  transition: transform 0.4s ease-in-out;
}
.accordion-section .accordion-content {
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
  background-color: #ffffff;
  padding: 0 18px;
}
.accordion-section .accordion-text {
  font-weight: 400;
  font-size: 14px;
  padding: 18px;
}
@media screen and (min-width: 768px) {
  .accordion-section .accordion {
    padding: 18px;
  }
}

.rotate {
  transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/components/accordion/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,6CAAA;AACJ;AACI;EACE,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACN;AACI;EACE,SAAA;AACN;AAOI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,+BAAA;AALN;AAQI;EACE,iBAAA;EACA,sCAAA;AANN;AASI;EACE,gBAAA;EACA,uCAAA;EACA,yBAAA;EACA,eAAA;AAPN;AAUI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AARN;AAWI;EA1DF;IA2DI,aAAA;EARJ;AACF;;AAYA;EACE,wBAAA;AATF","sourcesContent":[".accordion-section {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 20px;\n\n  .accordion {\n    background-color: #ffffff;\n    color: #444;\n    cursor: pointer;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border: none;\n    outline: none;\n    transition: background-color 0.3s ease-in-out;\n\n    .arrow {\n      border: 1px solid var(--sebrae-dark-gray2);\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    figure {\n      margin: 0;\n    }\n\n    &:hover,\n    &.active {\n      //background-color: #e6e6e6;\n    }\n\n    &-title {\n      margin: 0;\n      font-style: normal;\n      font-weight: 800;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      align-items: center;\n      letter-spacing: 0.02em;\n      color: var(--sebrae-dark-gray2);\n    }\n\n    &-icon {\n      margin-left: auto;\n      transition: transform 0.4s ease-in-out;\n    }\n\n    &-content {\n      overflow: hidden;\n      transition: max-height 0.4s ease-in-out;\n      background-color: #ffffff;\n      padding: 0 18px;\n    }\n\n    &-text {\n      font-weight: 400;\n      font-size: 14px;\n      padding: 18px;\n    }\n\n    @media screen and (min-width: 768px){\n      padding: 18px;\n    }\n  }\n}\n\n.rotate {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
